const decodeHtmlEntities = (value)=>{
    if (typeof document === 'undefined') {
        return value.replace(/&#39;/g, "'").replace(/&quot;/g, '"').replace(/&amp;/g, '&');
    }
    const textarea = document.createElement('textarea');
    textarea.innerHTML = value;
    return textarea.value;
};
/**
 * Looks up a translation key from `window.themeLocales` (set by js-locales.liquid).
 * Values are URL-encoded by the `url_param_escape` Liquid filter, so they are decoded here.
 * Falls back to the provided `fallback` string if the key is not found.
 */ export const t = (key, fallback = '')=>{
    var _window_themeLocales;
    const raw = (_window_themeLocales = window.themeLocales) === null || _window_themeLocales === void 0 ? void 0 : _window_themeLocales[key];
    return raw != null ? decodeHtmlEntities(decodeURIComponent(raw)) : fallback;
};
